<template>
  <component
    :is="clickable ? 'button' : 'div'"
    :type="clickable ? 'button' : undefined"
    class="hw-kpi"
    :class="{ 'hw-kpi-btn': clickable, active }"
    :style="color ? { borderTopColor: color } : {}"
    @click="onClick"
  >
    <slot>
      <span class="hw-label">{{ label }}</span>
      <span class="hw-kpi-value">{{ value }}</span>
      <span class="hw-kpi-foot">
        <span v-if="pill" class="hw-pill" :style="pillStyle">{{ pill }}</span>
        <span class="hw-muted">{{ note }}</span>
      </span>
    </slot>
  </component>
</template>

<script setup>
const props = defineProps({
  label: { type: String, default: '' },
  value: { type: [String, Number], default: '' },
  color: { type: String, default: '' },
  pill: { type: String, default: '' },
  pillStyle: { type: Object, default: () => ({}) },
  note: { type: String, default: '' },
  clickable: { type: Boolean, default: false },
  active: { type: Boolean, default: false }
})

const emit = defineEmits(['select'])

const onClick = () => {
  if (!props.clickable) return
  emit('select')
}
</script>

<style scoped src="./hrWorkforce.css"></style>

<style scoped>
.hw-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: #fff;
  border: 0;
  border-radius: 10px;
  border-top: 4px solid #0f766e;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  padding: 14px 16px;
  text-align: left;
  min-width: 0;
}
.hw-kpi-btn {
  cursor: pointer;
  transition: box-shadow 0.15s ease;
}
.hw-kpi-btn:hover {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);
}
.hw-kpi-btn.active {
  box-shadow: 0 0 0 2px #0f766e;
}
.hw-kpi-btn:focus-visible {
  outline: 2px solid #0f766e;
  outline-offset: 2px;
}
.hw-kpi-value {
  font-size: 1.85rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.hw-kpi-foot {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 2px;
}
</style>
